export default "__VITE_ASSET__96f1335d__"